import { render, staticRenderFns } from "./emarticonHome.vue?vue&type=template&id=828733fc&scoped=true"
import script from "./emarticonHome.vue?vue&type=script&lang=js"
export * from "./emarticonHome.vue?vue&type=script&lang=js"
import style0 from "./emarticonHome.vue?vue&type=style&index=0&id=828733fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828733fc",
  null
  
)

export default component.exports